import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { GymArticle } from "@/hooks/payments/useGymArticles";

interface ArticleFormProps {
  article?: GymArticle;
  onSubmit: (data: { name: string; description: string | null; price: number }) => Promise<void>;
  onCancel: () => void;
  isLoading?: boolean;
}

export const ArticleForm = ({ article, onSubmit, onCancel, isLoading }: ArticleFormProps) => {
  const [name, setName] = useState(article?.name ?? "");
  const [description, setDescription] = useState(article?.description ?? "");
  const [price, setPrice] = useState<number>(article?.price ?? 0);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim() || price <= 0) return;
    await onSubmit({
      name: name.trim(),
      description: description.trim() ? description.trim() : null,
      price,
    });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="space-y-2">
        <label className="text-sm font-medium">Nombre del artículo *</label>
        <Input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Ej. Botella de agua"
          required
        />
      </div>

      <div className="space-y-2">
        <label className="text-sm font-medium">Descripción</label>
        <Textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Detalles del artículo (opcional)"
          rows={3}
        />
      </div>

      <div className="space-y-2">
        <label className="text-sm font-medium">Precio *</label>
        <Input
          type="number"
          min="0"
          step="0.01"
          value={price === 0 ? "" : price}
          onChange={(e) => setPrice(Number(e.target.value) || 0)}
          placeholder="0"
          required
        />
      </div>

      <div className="flex gap-2">
        <Button type="submit" disabled={!name.trim() || price <= 0 || isLoading} className="flex-1">
          {isLoading ? "Guardando..." : "Guardar"}
        </Button>
        <Button type="button" variant="outline" onClick={onCancel} className="flex-1">
          Cancelar
        </Button>
      </div>
    </form>
  );
};
